import AddTask from './components/AddTask';
import { ToDo } from './components/ToDo';
import { ToCompleted } from './components/toCompleted';
import logo from './logo.svg';
import { useState,useEffect} from 'react';
import { useDrop } from 'react-dnd';

function App() {
  const [taskList,setTaskList] = useState([])
  const [completed, setCompleted] = useState([])
  const [complList, setComplList] = useState([])

  useEffect(()=>{
    let array= localStorage.getItem("taskList")

    if(array){
      setTaskList(JSON.parse(array))
    }
  },[])

  const [{isOver}, drop] = useDrop(()=>({
    accept: "todo",
    drop:(item) => addToCompleted(item.id,item.projectName,item.taskDescription,
      item.timestamp, item.duration),
    collect: (monitor) =>({
      isOver: !!monitor.isOver(),
    })

  }))

  const addToCompleted = (id,projectName,taskDescription,timestamp,duration) =>{
    const moveTask = taskList.filter((task) => id === task.id);
    setCompleted((completed) => [...completed,{moveTask,projectName,
    taskDescription,timestamp,duration}])
    let tempList = taskList;
    tempList.push({
        projectName,
        taskDescription,
        timestamp:timestamp,
        duration: 0
    })
    localStorage.setItem("taskListCompl", JSON.stringify(tempList))
  }

  return (
  <>
  <h1 className='text-2xl font-bold py-4 pl-6' >TestTask</h1>
  <div className="flex flex-row items-center">
  <p className='text-xl pl-6'>Нажмите</p> 
  <AddTask taskList={taskList} setTaskList={setTaskList} />
  <p className='text-xl pl-6'>чтобы добавить новую задачу</p>
  </div>
  <div  className='flex flex-row'>

 
  <div className='w-full'>
    <h2 className='ml-6 text-xl font-semibold w-3/4 max-w-lg my-4
    py-2 px-4 bg-gray-200'>Сделать:</h2>
    <div className='ml-6 flex flex-col-reverse' >
    {taskList.map((task,i)=>
    <>
      <ToDo key={i} task={task} index={i} taskList={taskList}
      setTaskList={setTaskList} />
    </>
    )}
    </div>
  </div>
  <div className='w-full flex flex-col' ref={drop}>
    <h2 className='text-xl font-semibold w-3/4 max-w-lg my-4
    py-2 px-4 bg-gray-200' > Сделано</h2>
     {completed.map((task,i)=>
    <>
      <ToCompleted key={i} task={task} index={i} complList={complList}
      setComplList={setComplList} />
    </>
    )}
  </div>
  </div>
  </>
  );
}

export default App;
